import { inherits } from 'util';
import Subprovider from 'web3-provider-engine/dist/es5/subproviders/subprovider.js';
import eventMixin from './event-mixin';

function EventHookSubprovider() {
  eventMixin(this);
  this.id = 1;
}

inherits(EventHookSubprovider, Subprovider);

EventHookSubprovider.prototype.handleRequest = function(payload, next) {

  switch (payload.method) {

    case 'eth_sendTransaction':
      var id = this.id++;
      this.emit('tx-send', { id, payload });
      return next((error, result, cb) => {
        if (error) {
          this.emit('tx-send-error', { id, error })
        } else {
          this.emit('tx-send-success', { id, result })
          const check = () => {
            this.engine.sendAsync({
              "jsonrpc": "2.0",
              "method": "eth_getTransactionReceipt",
              "params": [result]
            }, (error, result) => {
              if (error) {
                this.emit('tx-send-error', { id, error })
              } else if (result.result && result.result.blockHash) {
                this.emit('tx-send-mined', { id, result })
                this.engine.removeListener('block', check);
              }
            })
          }
          this.engine.on('block', check);
          check();
        }
        cb();
      })
    default:
      return next()
  }
}

export default EventHookSubprovider;


// WEBPACK FOOTER //
// ./src/api/event-hook-subprovider.js